export const init = () => {
  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separator;

  // DEFINE 'productList' TRACKER
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.product.productList
  );

  const containerSpotlight = '#lpt-tg div.slick-track';
  const containerSpotlightFloor = '#spotlightFloor div.product';
  const containerProductFloor = '#listing-product';
  const containerSparePartProductFloor = '#listing-product.spare-part';
  const containerCrossSellProduct = '#often-bought-list .plv2-element';

  const getLabel = (element, index) => {
    const model = fwk.utils.pagelist.getModel(element);
    return (
      AnalyticsConstants.slick.defaultValuePosition +
      index +
      sep +
      model.name +
      sep +
      model.id
    );
  };
  const getNewLabel = (element, index) => {
    const model = fwk.utils.pagelist.parseProduct(
      element.closest('article.dkt-product')
    );
    return (
      AnalyticsConstants.slick.defaultValuePosition +
      index +
      sep +
      model.name +
      sep +
      model.id
    );
  };
  const getValue = element => {
    const model = fwk.utils.pagelist.parseProduct(element.closest('article'));
    return model.price;
  };
  const getNewSparePartLabel = (element, index) => {
    const model = fwk.utils.pagelist.parseSparePart(
      element.closest('div.pl-element .inner-element')
    );
    return (
      AnalyticsConstants.slick.defaultValuePosition +
      index +
      sep +
      model.name +
      sep +
      model.id
    );
  };
  /*
   * SPOTLIGHT
   */
  const eventSpotlight = new AnalyticsClickEvent(
    'eventSpotlight',
    tracker.defaultEvent()
  );
  eventSpotlight.options.action = 'PushSpotlight';
  eventSpotlight.domContainer = containerSpotlight;
  eventSpotlight.domElement = 'a';
  eventSpotlight.getLabel = $element => {
    const slide = $element.closest('.slick-slide');
    const index =
      slide
        .closest('.slick-track')
        .find('> .slick-slide:not(.slick-cloned)')
        .index(slide) + 1;
    return getLabel($element, index);
  };
  eventSpotlight.getValue = getValue;
  //	eventSpotlight.postAction(fwk.shoppingtool.reBind.bind(fwk.shoppingtool));
  tracker.addEvent(eventSpotlight);

  /*
   * SPOTLIGHT FLOOR
   */
  const eventSpotlightFloor = new AnalyticsClickEvent(
    'eventSpotlightFloor',
    tracker.defaultEvent()
  );
  eventSpotlightFloor.options.action = 'PushSpotlightFloor';
  eventSpotlightFloor.domContainer = containerSpotlightFloor;
  eventSpotlightFloor.domElement = 'a';
  eventSpotlightFloor.getLabel = $element => {
    const product = $element.closest('.product');
    const index = $('.product').index(product) + 1;
    return getLabel($element, index);
  };
  eventSpotlightFloor.getValue = getValue;
  //	eventSpotlightFloor.postAction(fwk.shoppingtool.reBind.bind(fwk.shoppingtool));
  tracker.addEvent(eventSpotlightFloor);

  /*
   * LISTING PRODUCT spare-part
   */
  const eventSparePartProduct = new AnalyticsClickEvent(
    'eventSparePartProduct',
    tracker.defaultEvent()
  );
  eventSparePartProduct.options.action = 'PositionClickOnSparePartProduct';
  eventSparePartProduct.domContainer = containerSparePartProductFloor;
  eventSparePartProduct.domElement = 'div.pl-element .inner-element';
  eventSparePartProduct.getLabel = $element => {
    const product = $element.closest('div.pl-element .inner-element');
    const index = $('div.pl-element .inner-element').index(product) + 1;
    return getNewSparePartLabel($element, index);
  };
  eventSparePartProduct.postAction($element => {
    const model = fwk.utils.pagelist.parseSparePart(
      $element.closest('div.pl-element')
    );
    // Send EC-CLICK
    fwk.enhanced.sendClick(model);
  });

  tracker.addEvent(eventSparePartProduct);

  /*
   * LISTING PRODUCT
   */
  const eventListingProduct = new AnalyticsClickEvent(
    'eventListingProduct',
    tracker.defaultEvent()
  );
  eventListingProduct.options.action = 'PositionClick';
  eventListingProduct.domContainer = containerProductFloor;
  eventListingProduct.domElement = 'article';
  eventListingProduct.postAction($element => {
    const model = fwk.utils.pagelist.parseProduct(
      $element.closest('article.dkt-product')
    );
    const shoppingTool = fwk.shoppingtool.get();
    if (shoppingTool && shoppingTool.st && !shoppingTool.st.includes('navigation-breadcrum')) {
      fwk.shoppingtool.set('standard', shoppingTool.std);
    }
    // Send EC-CLICK
    fwk.enhanced.set(model);
    fwk.enhanced.sendClick(model);
  });
  eventListingProduct.getLabel = $element => {
    const product = $element.closest('article.dkt-product');
    const index = $('article.dkt-product').index(product) + 1;
    return getNewLabel($element, index);
  };
  tracker.addEvent(eventListingProduct);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/product/product-list-tracker.js